import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';


const OrderFrequencyChart = props => {

    const data = formatIndex(props.content, props.period);

    return (
        <BarChart width={props.width} height={props.height} data={data} style={{ margin: 'auto' }}>
            <XAxis dataKey="index" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" fill="rgb(2,136,209)">
                {
                    data.map(item => {
                        const color = COLORS[parseInt(item.colorIndex)];
                        return <Cell fill={color} />;
                    })
                }
            </Bar>
        </BarChart>
    );
}

const formatIndex = (arr, period) => {
    if (period === "hour") {
        return arr.map(item => {
            return {
                ...item, colorIndex: item.index, index: item.index.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                })
            }
        })
    } else {
        return arr.map(item => {
            return {
                ...item, index: getDayByIndex(item.index), colorIndex: item.index
            }
        })
    }
}

export default OrderFrequencyChart;

const getDayByIndex = index => {
    switch (index) {
      case 1: return "Monday";
      case 2: return "Tuesday";
      case 3: return "Wednesday";
      case 4: return "Thursday";
      case 5: return "Friday";
      case 6: return "Saturday";
      case 7: return "Sunday";
      default: return null;
    }
  }

const COLORS = [
    "#8B0000",
    "#DC143C",
    "#FF7F50",
    "#FF8C00",
    "#FFD700",
    "#EEE8AA",
    "#9ACD32",
    "#7FFF00",
    "#228B22",
    "#00FA9A",
    "#66CDAA",
    "#008080",
    "#40E0D0",
    "#5F9EA0",
    "#6495ED",
    "#9400D3",
    "#800080",
    "#DA70D6",
    "#FFB6C1",
    "#D8BFD8",
    "#FFEFD5",
    "#B0C4DE",
    "#708090",
    "#D8BFD8"
]


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderFrequencyChart.js